<template>
  <div class="from_material">
    <div class="material_list">
      <repotree
        @folderClick='folderClick'
        :isHidePersonRepo='false'
      ></repotree>
    </div>
    <div
      class="material_piccontent"
      v-loading='picloading'
      element-loading-text="拼命加载中"
    >
      <el-scrollbar
        class="material_piclist"
        v-show="picList.length > 0"
      >
        <div
          class="each_material_pic"
          v-for="item in picList"
          @click.stop='choiceOrCancleCurrentHeadImg(item)'
        >
          <el-image
            style="width: 120px; height: 120px"
            :src="item.cover_img"
            :alt='alt'
            :fit="fit"
            class="el-image-class"
          >
            <div
              slot="error"
              class="image-slot"
            >
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div
            class="each_insert_opacity"
            v-show="isCurrentChoice(item)"
          >
            <div class="each_insert_choice">
              <span class="iconfont icon-check"></span>
            </div>
          </div>

          <div
            class="each_insert_opacity each_insert_opacity_preview"
            style="background:rgba(0, 0, 0, 0.5);"
            title="点击选中"
          >
            <span
              class="iconfont icon-yulan1"
              style="color:#fff;position:absolute;bottom:0px;right:4px;font-size:28px;"
              @click.stop='previewPicture(item)'
              title="预览大图"
            ></span>
          </div>

          <div
            class="title_pic"
            :title="item.title"
          >{{item.title}}</div>

        </div>
      </el-scrollbar>
      <div
        class="page"
        v-show="picList.length > 0"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pager-count='pagerCount'
          layout="total,prev, pager, next, jumper"
          :total="picTotal"
        >
        </el-pagination>
      </div>

      <div
        class="no_data_show"
        v-show="picList.length === 0"
      >暂无数据</div>

    </div>

  </div>
</template>

<script>
import repotree from '../repotree/repotree'
import * as api from '../../../api'
var TimeFn = null
export default {
  name: 'fromMaterial',
  components: {
    repotree
  },
  props: {
    choiceUrlList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1,
      currentFolder: '',
      pageSize: 20,
      picList: [],
      picTotal: 0,
      picloading: false,
      fit: 'contain',
      alt: '图片加载失败',
      pagerCount: 5
    }
  },
  computed: {
    materialConditionData () {
      return this.$store.state.editor.materialConditionData
    },
    isCurrentChoice () {
      return function (item) {
        if (this.choiceUrlList.length > 0) {
          var k = 0
          for (var i = 0; i < this.choiceUrlList.length; i++) {
            if (!this.choiceUrlList[i].hasOwnProperty('id') || (this.choiceUrlList[i].hasOwnProperty('id') && this.choiceUrlList[i].id !== item.id)) {
              k++
            } else {
              break;
            }
          }
          if (k == this.choiceUrlList.length) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.getMaterialPicList(val - 1, this.currentFolder)
    },
    folderClick (data) {
      this.currentFolder = data
      this.picList = []
      this.picTotal = 0
      this.currentPage = 1
      this.getMaterialPicList(0, data)
    },
    getMaterialPicList (pagenow, data) {
      this.picloading = true
      this.currentPage = pagenow + 1
      var option = {
        ...this.$store.getters.baseOption,
        "params": {
          'sortTime': 'time_update', // 排序时间（创建时间：time_create | 更新时间:time_update）
          'sortRule': 'desc', // 排序规则（正序:asc | 倒叙: desc）
          'definition': '', // 清晰度（高清:high|标清:standard）
          'composition': 'all', // 构图（全部:all/横图:heng/竖图:shu/方图:fang）
          'widthAndHigh': 0,
          'width': 0,
          'height': 0,
          'format': '',
          'startSize': '',
          'endSize': '',
          'flag_issue': 'all', // 签发状态 全部：all  已签：yes，未签：no
          'flag_push': 'all', // 推送状态： 全部：all  已推送：yes  未推送：no
          'flag_audit': 'all', // 审核状态： 全部：all  已审核：yes  未审核：no  审核中： doing
          'folderId': data.id,
          'type': 'picture', // 素材类型：图片 picture 视频 video 音频 audio  附件 file
          'tags': [], // 标签
          'searchValue': '',
          'searchType': 'all',
          'pageSize': this.pageSize,
          'pageNum': pagenow,
          'startTime': '',
          'endTime': ''
        }
      }

      api._post(_IMGFILEURL_ + 'public/pageQuery', option).then((resp) => {
        if (resp.code == 200) {
          this.picList = resp.data.content
          this.picTotal = resp.data.totalElements
        } else {
          this.picList = []
          this.picTotal = 0
        }
        this.picloading = false
      }).catch((error) => {
        this.picList = []
        this.picTotal = 0
        console.log(error)
        this.picloading = false
      })
    },
    choiceOrCancleCurrentHeadImg (item) {
      this.$emit('choiceCancleImg', item)
    },
    previewPicture (item) {
      this.$root.eventHub.$emit('getMatterDetail', item, 'imgDetail')
    }

  }
}
</script>

<style lang='stylus' scoped>
.from_material
  all-length()
  position relative
  display flex

  .material_list
    width 180px
    height 100%
    border-right 1px solid rgba(0, 0, 0, 0.15)

  .material_piccontent
    position relative
    flex 1
    height 100%

    .no_data_show
      position absolute
      top 40%
      left 40%

    .material_piclist
      clear both
      box-sizing border-box
      padding-top 24px
      height 500px

      .each_material_pic
        position relative
        float left
        box-sizing border-box
        margin-bottom 30px
        margin-left 24px
        width 120px
        height 120px
        cursor pointer

        .title_pic
          overflow hidden
          margin-top 0px
          width 100%
          color #606266
          text-align center
          text-overflow ellipsis
          white-space nowrap
          font-size 14px

        .each_insert_opacity
          position absolute
          top 0
          left 0
          display flex
          justify-content center
          align-items center
          width 100%
          height 100%
          background rgba(0, 0, 0, 0.5)

          .each_insert_choice
            width 62px
            height 60px
            border 3px solid #fff
            border-radius 50%
            text-align center
            line-height 60px

            span
              color #fff
              font-size 40px

        .each_insert_opacity_preview
          display none

        img
          display block
          width 100%
          height 100%
          border none

        &:hover
          .each_insert_opacity_preview
            display block

    .page
      height 70px
      center()
      position absolute
      bottom 0
      left 10px
</style>
